import { TypedDocumentString } from "@leplein/graphql-public/clients/graphql-qrcode-client/graphql";
import axios from "axios";
import { ExecutionResult } from "graphql";

export const graphQLRequest = async <TResult, TVariables>(
	query: TypedDocumentString<TResult, TVariables>,
	...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
) => {
	const { data } = await axios.post<ExecutionResult<TResult>>(`${import.meta.env.VITE_API_BASE_URL}/graphql`, {
		query: query,
		variables,
	});

	if (data?.errors) {
		throw new Error(data?.errors[0]?.message);
	}

	return data?.data;
};
